export function formatRate(value) {
  if (value === "" || value == null) return "—"
  const num = parseFloat(value)
  if (isNaN(num)) return "—"
  return `${num.toFixed(2)}%`
}

export function formatMoney(value) {
  if (value == null || isNaN(value)) return "—"
  return new Intl.NumberFormat("en-NZ", {
    style: "currency",
    currency: "NZD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
}

export function buildComparisonCard(row, fields) {
  const data = row.dataset
  const title = data.providerName || ""
  const subtitle = data.productName || data.fundName || ""
  const itemId = data.itemId || data.fundId || ""

  const rows = fields.map(field => {
    let value = data[field.key] || ""
    if (field.format === "rate") value = formatRate(value)
    else if (field.format === "money") value = formatMoney(parseFloat(value))
    else if (value === "") value = "—"

    return `
      <div class="flex justify-between">
        <dt class="text-stone-500">${field.label}</dt>
        <dd class="font-medium">${value}</dd>
      </div>`
  }).join("")

  return `
    <div class="moneysmart-card p-4" data-compare-card-id="${itemId}">
      <h4 class="font-semibold text-stone-900 text-sm mb-1">${title}</h4>
      ${subtitle ? `<p class="text-stone-600 text-sm mb-3">${subtitle}</p>` : ""}
      <dl class="space-y-2 text-sm">${rows}</dl>
    </div>`
}

export function buildFeeRow(label, value) {
  return `
    <div class="flex justify-between py-1">
      <span class="text-stone-500 text-sm">${label}</span>
      <span class="font-medium text-sm">${value || "—"}</span>
    </div>`
}
